import { GridContainer, GridItem, GridRow, gridConfig } from '@tvg/fuse-design/responsive-grid';
import React from 'react';
import styled from 'styled-components';
import { TopRow } from './TopRow';
import { BottomRow } from './BottomRow';
import Pagination from './Pagination/Pagination';
import { ProductCardList } from './ProductCardList';

const GridContainerStyled = styled(GridContainer)`
  && {
    padding: 0;
    place-items: flex-start;
    grid-template-rows: max-content;
  }

  & .pagination-row {
    margin-top: 12px;
  }

  & .fuse-swatch ~ p {
    margin-bottom: 0;
  }

  .fuse-pagination__list-item {
    display: flex;
    align-items: center;
    margin-right: 0;
    width: auto;
    span {
      margin-right: var(--spacing-global-space3);
      margin-left: calc(0px - var(--spacing-global-space2));
    }

    @media screen and (min-width: ${gridConfig.s.minWidth}) {
      & {
        min-width: var(--spacing-global-space7);
      }
      span {
        margin-left: 0;
        min-width: var(--spacing-global-space5);
      }
    }
  }
`;

export function CardGrid() {
  return (
    <GridContainerStyled className="container">
      <TopRow />

      <ProductCardList />

      <BottomRow />

      <GridRow className="row">
        <GridItem xxs="12" className="grid-item pagination-row">
          <Pagination />
        </GridItem>
      </GridRow>
    </GridContainerStyled>
  );
}
